import PropTypes from 'prop-types';
import React from 'react';
import TypedCell from './TypedCell';
import EditCell from './EditCell';
import { shouldRenderLink } from 'common/util/urlHelpers';

const EMPTY_URL = {
  url: '',
  description: ''
};

function URLCell({ isEditing, value, isError, updateCell, isDropping, format }) {
  let a = null;
  if (isEditing) {
    // unable to edit description - need better UI to break out fields
    return <EditCell value={(isError ? EMPTY_URL : value) || EMPTY_URL} updateCell={updateCell} />;
  }
  if (value) {
    const { url, description } = value;
    const label = description || url;
    if (shouldRenderLink(url)) {
      a = (
        <a target="_blank" className="url-cell" href={url} rel="noreferrer">
          {label}
        </a>
      );
    } else {
      a = <span data-url={url}>{label}</span>;
    }
  }
  return <TypedCell isDropping={isDropping} value={a} format={format} />;
}

URLCell.propTypes = {
  isDropping: PropTypes.bool,
  isEditing: PropTypes.bool,
  isError: PropTypes.bool,
  updateCell: PropTypes.func,
  value: PropTypes.any,
  format: PropTypes.object
};

export default URLCell;
